<template>
  <el-card shadow="never">
    <el-form :model="form" label-width="120px">
      <el-form-item label="绑定账户">
        <el-select v-model="form.accountId" placeholder="请选择百度推广账户" filterable clearable style="width: 360px;">
          <el-option v-for="item in accountOptions" :key="item.id" :label="item.username" :value="item.id" />
        </el-select>
        <el-button style="margin-left: 12px;" @click="loadConfig">加载配置</el-button>
      </el-form-item>

      <template v-if="mode === 'access'">
        <el-form-item label="签名配置(JSON)">
          <el-input v-model="form.signatureJson" type="textarea" :rows="8" />
        </el-form-item>
      </template>

      <template v-else>
        <el-form-item label="入站映射(JSON)">
          <el-input v-model="form.inboundJson" type="textarea" :rows="10" />
        </el-form-item>
        <el-form-item label="回传映射(JSON)">
          <el-input v-model="form.callbackJson" type="textarea" :rows="8" />
        </el-form-item>
      </template>

      <el-form-item>
        <el-button type="primary" @click="saveConfig" :loading="saving">保存配置</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {
  fetchBaiduAifanfanConfig,
  saveBaiduAifanfanConfig,
  fetchPromotionAccountOptions
} from '@/services/baiduAifanfanApi';

function parseJsonText(text, fallback) {
  try {
    return JSON.parse(text);
  } catch (error) {
    return fallback;
  }
}

export default {
  name: 'BaiduAifanfanConfig',
  props: {
    mode: {
      type: String,
      default: 'access'
    }
  },
  data() {
    return {
      saving: false,
      accountOptions: [],
      form: {
        accountId: '',
        signatureJson: JSON.stringify([
          {
            targetField: 'signature',
            transformType: 'FIXED',
            transformConfigJson: {
              signatureSource: 'body',
              signatureField: 'sign',
              signatureFields: ['clueId', 'commitTime'],
              signatureCase: 'upper',
              secret: ''
            }
          }
        ], null, 2),
        inboundJson: JSON.stringify([
          { targetField: 'clueId', sourceFieldPath: '$.clueId', transformType: 'RAW' },
          { targetField: 'ucid', sourceFieldPath: '$.ucid', transformType: 'RAW' },
          { targetField: 'commitTime', sourceFieldPath: '$.commitTime', transformType: 'RAW' },
          { targetField: 'phoneCandidate', sourceFieldPath: '$.cluePhoneNumber', transformType: 'PHONE' },
          { targetField: 'solutionTypeName', sourceFieldPath: '$.solutionTypeName', transformType: 'RAW' },
          { targetField: 'unitId', sourceFieldPath: '$.unitId', transformType: 'RAW' },
          { targetField: 'keyword', sourceFieldPath: '$.keyword', transformType: 'RAW' },
          { targetField: 'planName', sourceFieldPath: '$.planName', transformType: 'RAW' },
          { targetField: 'planId', sourceFieldPath: '$.planId', transformType: 'RAW' },
          { targetField: 'aiServiceMessageNum', sourceFieldPath: '$.aiServiceMessageNum', transformType: 'RAW' },
          { targetField: 'humanServiceMsgCount', sourceFieldPath: '$.humanServiceMsgCount', transformType: 'RAW' },
          { targetField: 'clueUserMsgCount', sourceFieldPath: '$.clueUserMsgCount', transformType: 'RAW' },
          { targetField: 'imName', sourceFieldPath: '$.imName', transformType: 'RAW' },
          { targetField: 'formDetail', sourceFieldPath: '$.formDetail', transformType: 'RAW' },
          { targetField: 'area', sourceFieldPath: '$.area', transformType: 'RAW' },
          { targetField: 'areaProvince', sourceFieldPath: '$.areaProvince', transformType: 'RAW' },
          { targetField: 'flowChannelName', sourceFieldPath: '$.flowChannelName', transformType: 'RAW' },
          { targetField: 'wechatAccount', sourceFieldPath: '$.wechatAccount', transformType: 'RAW' },
          { targetField: 'unitName', sourceFieldPath: '$.unitName', transformType: 'RAW' },
          { targetField: 'searchWord', sourceFieldPath: '$.searchWord', transformType: 'RAW' },
          { targetField: 'siteId', sourceFieldPath: '$.siteId', transformType: 'RAW' },
          { targetField: 'siteName', sourceFieldPath: '$.siteName', transformType: 'RAW' },
          { targetField: 'siteUrl', sourceFieldPath: '$.siteUrl', transformType: 'RAW' },
          { targetField: 'pageId', sourceFieldPath: '$.pageId', transformType: 'RAW' },
          { targetField: 'bdVid', sourceFieldPath: '$.bdVid', transformType: 'RAW' },
          { targetField: 'consultUrl', sourceFieldPath: '$.consultUrl', transformType: 'RAW' },
          { targetField: 'phoneRisk', sourceFieldPath: '$.phoneRisk', transformType: 'RAW' },
          { targetField: 'phoneDup', sourceFieldPath: '$.phoneDup', transformType: 'RAW' },
          { targetField: 'agentFilter', sourceFieldPath: '$.agentFilter', transformType: 'RAW' },
          { targetField: 'phoneAgentRisk', sourceFieldPath: '$.phoneAgentRisk', transformType: 'RAW' },
          { targetField: 'intentIdentify', sourceFieldPath: '$.intentIdentify', transformType: 'RAW' },
          { targetField: 'antiLabel', sourceFieldPath: '$.antiLabel', transformType: 'RAW' },
          { targetField: 'phoneSummary', sourceFieldPath: '$.phoneSummary', transformType: 'RAW' },
          { targetField: 'appointReachRes', sourceFieldPath: '$.appointReachRes', transformType: 'RAW' },
          { targetField: 'additionalContent', sourceFieldPath: '$.additionalContent1', transformType: 'RAW' },
          { targetField: 'studentName', sourceFieldPath: '$.name', transformType: 'RAW' },
          { targetField: 'phoneCandidate', sourceFieldPath: '$.phone', transformType: 'PHONE' },
          { targetField: 'projectCandidate', sourceFieldPath: '$.project', transformType: 'RAW' },
          { targetField: 'projectCodes', sourceFieldPath: '$.project', transformType: 'RAW' },
          { targetField: 'city', sourceFieldPath: '$.city', transformType: 'RAW' },
          { targetField: 'remark', sourceFieldPath: '$.remark', transformType: 'RAW' },
          { targetField: 'sourceSystem', sourceFieldPath: '$.sourceSystem', transformType: 'RAW' },
          { targetField: 'sourceCode', sourceFieldPath: '$.sourceCode', transformType: 'RAW' },
          { targetField: 'accountId', sourceFieldPath: '$.accountId', transformType: 'RAW' }
        ], null, 2),
        callbackJson: JSON.stringify([
          { targetField: 'REVIEW_APPROVED', transformType: 'FIXED', transformConfigJson: { markType: 2002 } },
          { targetField: 'FOLLOW_CONFIRMED', transformType: 'FIXED', transformConfigJson: { markType: 2004 } },
          { targetField: 'ORDER_CREATED', transformType: 'FIXED', transformConfigJson: { markType: 2007 } },
          { targetField: 'INVALID_PHONE', transformType: 'FIXED', transformConfigJson: { markType: 1003 } }
        ], null, 2)
      }
    };
  },
  created() {
    this.loadAccounts();
  },
  methods: {
    async loadAccounts() {
      const res = await fetchPromotionAccountOptions();
      this.accountOptions = res.data.list || [];
    },
    async loadConfig() {
      const res = await fetchBaiduAifanfanConfig({ accountId: this.form.accountId || null });
      const list = res.data || [];
      const signature = list.filter((item) => item.configScope === 'SIGNATURE');
      const inbound = list.filter((item) => item.configScope === 'INBOUND');
      const callback = list.filter((item) => item.configScope === 'CALLBACK');
      if (signature.length) this.form.signatureJson = JSON.stringify(signature.map(this.normalizeConfigRow), null, 2);
      if (inbound.length) this.form.inboundJson = JSON.stringify(inbound.map(this.normalizeConfigRow), null, 2);
      if (callback.length) this.form.callbackJson = JSON.stringify(callback.map(this.normalizeConfigRow), null, 2);
    },
    normalizeConfigRow(item) {
      return {
        sourceFieldPath: item.sourceFieldPath,
        targetField: item.targetField,
        transformType: item.transformType,
        transformConfigJson: item.transformConfigJson,
        requiredFlag: item.requiredFlag,
        enabled: item.enabled
      };
    },
    async saveConfig() {
      this.saving = true;
      try {
        const payload = {
          accountId: this.form.accountId || null
        };
        if (this.mode === 'access') {
          payload.signatureConfigs = parseJsonText(this.form.signatureJson, []);
        } else {
          payload.inboundMappings = parseJsonText(this.form.inboundJson, []);
          payload.callbackMappings = parseJsonText(this.form.callbackJson, []);
        }
        await saveBaiduAifanfanConfig(payload);
        this.$message.success('配置保存成功');
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
